import { render, staticRenderFns } from "./block-menu.vue?vue&type=template&id=4c8eca5d&scoped=true"
import script from "./block-menu.vue?vue&type=script&lang=js"
export * from "./block-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8eca5d",
  null
  
)

export default component.exports